/**
 * Single place for tooltip styling.
 *
 * Design's spec is here:
 * https://www.figma.com/file/01KWBdMZg5QM9SRS1pQq0z/Design-System----Robot-Styles?node-id=519%3A3243&t=22hDrNNVQuwxI6l3-1
 * TODO: This is not handling handling night mode as specified.
 */
import {Colors, hexToRGB} from '@wandb/common/css/globals.styles';
import {Popup} from 'semantic-ui-react';
import styled from 'styled-components';

export const Tooltip = styled(Popup).attrs({
  basic: true, // This removes the pointing arrow.
  mouseEnterDelay: 500,
  popperModifiers: {
    preventOverflow: {
      // Prevent popper from erroneously constraining the popup.
      // Without this, tooltips in single row table cells get positioned under the cursor,
      // causing them to immediately close.
      boundariesElement: 'viewport',
    },
  },
})`
  && {
    color: ${Colors.WHITE};
    background: ${Colors.GRAY_800};
    border-color: ${Colors.GRAY_700};
    box-shadow: 0px 4px 6px ${hexToRGB(Colors.BLACK, 0.2)};
    font-size: 14px;
    line-height: 140%;
    max-width: 300px;
  }
`;
